import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import {
  useRecoilValue,
  useResetRecoilState,
  useRecoilCallback,
  useRecoilState
} from 'recoil'

import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Modal,
  ModalHead,
  ModalBody,
  ModalFoot,
  Select,
  SELECT_VARIANT_WITH_CHECKBOX
} from 'mailup-web-components'

import {
  modalListFilterState,
  pageState
} from 'Pages/ScheduledSendings/recoil/state/page'

import {
  fetchListsCallback,
  fetchScheduledCallback
} from 'Pages/ScheduledSendings/recoil/callbacks/callbacks'

const ModalListFilter = () => {
  const intl = useIntl()
  const [{ show, value }, setModalState] = useRecoilState(modalListFilterState)
  const { allLists } = useRecoilValue(pageState)

  const handleClose = useResetRecoilState(modalListFilterState)

  const fetchLists = useRecoilCallback(fetchListsCallback, [])
  const fetchScheduled = useRecoilCallback(fetchScheduledCallback, [])

  useEffect(() => {
    fetchLists()
  }, [])

  const handleChange = v => {
    setModalState(prev => ({ ...prev, value: [...v] }))
  }

  const handleSave = () => {
    fetchScheduled({ idLists: value })
    handleClose()
  }

  return (
    <Modal
      show={show}
      showClose
      closeOnOverlayClick
      onClose={handleClose}
      data-mu-test='scheduled-sendings-modal-list-filter'
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.ScheduledMailing.SelectListModalTitle'
        })}
      />
      <ModalBody>
        <Select
          value={value}
          options={allLists}
          multiple
          variant={SELECT_VARIANT_WITH_CHECKBOX}
          onChange={handleChange}
          placeholder={intl.formatMessage({
            id: 'Load.ScheduledMailing.SelectListModalPlaceholder'
          })}
        />
      </ModalBody>
      <ModalFoot>
        <Button kind={BUTTON_VARIANT_SECONDARY} onClick={handleClose}>
          {intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
        </Button>
        <Button kind={BUTTON_VARIANT_PRIMARY} onClick={handleSave}>
          {intl.formatMessage({ id: 'Load.MailupCommon.Save' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalListFilter
